import AdyenBtn from '../../adyen-button';

const IdealButton = () => {
    return <AdyenBtn
        paymentType='ideal'
        paymentMethodConfiguration={{
            name: 'iDEAL'
        }}
    />;
};

export default IdealButton;
